import React from 'react';
import { Route } from 'react-router-dom';
import AutresParametres from '../pages/parametres/AutresParametres';
import Avenants from '../pages/parametres/avenants/Avenants';
import Carosseries from '../pages/parametres/carosseries/Carosseries';
import Categories from '../pages/parametres/categories/Categories';
import TauxCommissions from '../pages/parametres/commissions/TauxCommissions';
import Energies from '../pages/parametres/conversions/Energies';
import Fractionnements from '../pages/parametres/fractionnements/Fractionnements';
import Garanties from '../pages/parametres/Garanties';
import SousGaranties from '../pages/parametres/SousGaranties';
import Marques from '../pages/parametres/marques/Marques';
import Banques from '../pages/parametres/other-parameters/Banques';
import CausesSinistres from '../pages/parametres/other-parameters/CausesSinistres';
import Etablissements from '../pages/parametres/other-parameters/Etablissements';
import Experts from '../pages/parametres/other-parameters/Experts';
import Exercices from '../pages/parametres/other-parameters/Exercices';
import NatureActe from '../pages/parametres/other-parameters/NatureActe';
import Prejudices from '../pages/parametres/other-parameters/Prejudices';
import Professions from '../pages/parametres/other-parameters/Professions';
import SommeMinList from '../pages/parametres/other-parameters/SommeMini';
import TypeProfils from '../pages/parametres/other-parameters/TypeProfils';
import Villes from '../pages/parametres/other-parameters/Villes';
import Taxes from '../pages/parametres/taxes/Taxes';
import Usages from '../pages/parametres/usages/Usages';
import Reductions from '../pages/parametres/reductions/Reductions';
import DetailsReductions from '../pages/parametres/reductions/DetailsReductions';
import ParametresTarification from '../pages/parametres/ParametresTarification';
import ParametresSinistres from '../pages/parametres/ParametresSinistres';
import ProduitAttestation from '../pages/parametres/produit-attestation/ProduitAttestation';
import TypesAttestations from '../pages/parametres/attestations/TypesAttestations';
import Accessoires from '../pages/parametres/accessoires/Accessoires';
import CleDeRepartition from '../pages/parametres/other-parameters/cles/CleDeRepartition';
import ClesRepartition from '../pages/parametres/other-parameters/cles/ClesRepartition';
import EntiteConstats from '../pages/parametres/entiteConstat/EntiteConstats';
import BaremeEvaluationOuvertureSinistre from '../pages/parametres/other-parameters/bareme-sinistre/BaremeEvaluationOuvertureSinistre';
import AddLieu from '../pages/parametres/other-parameters/AddLieu';
import NumeroConfig from '../pages/parametres/other-parameters/NumeroConfig';
import NumeroPoliceAddPage from '../pages/parametres/other-parameters/NumeroPoliceAddPage';
import NumeroSinistreAddPage from '../pages/parametres/other-parameters/NumeroSinistreAddPage';
import TypePieces from '../pages/parametres/other-parameters/TypePieces';
import TypeEtablissements from '../pages/parametres/other-parameters/TypeEtablissements';
import PenalitesCession from '../pages/parametres/other-parameters/PenaliteCession';
import ListAgeLimitePaiementRente from '../pages/parametres/agelimiteRente/ListAgeLimitePaiementRente';
import Smigs from '../pages/parametres/smig/Smigs';
import PretiumDoloris from '../pages/parametres/pretiumDoloris/PretiumDoloris';
import ValeurPointIP from '../pages/parametres/valeurPoint/ValeurPointIP';
import SommeMin from '../pages/parametres/other-parameters/SommeMini';

const ParametresRoutes = () => (
    <>
        <Route path="/garanties" element={<Garanties />} />
        <Route path="/sous-garanties/:garantieId" element={<SousGaranties />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/reductions" element={<Reductions />} />
        <Route path="/details-reduction/:reductionId" element={<DetailsReductions />} />
        <Route path="/tarification" element={<ParametresTarification />} />
        <Route path="/autres-parametres" element={<AutresParametres />} />
        <Route path="/parametres/avenants" element={<Avenants />} />
        <Route path="/parametres/carosseries" element={<Carosseries />} />
        <Route path="/parametres/taxes" element={<Taxes />} />
        <Route path="/parametres/marques" element={<Marques />} />
        <Route path="/parametres/accessoires" element={<Accessoires />} />
        <Route path="/parametres/conversion" element={<Energies />} />
        <Route path="/parametres/Usages" element={<Usages />} />
        <Route path="/parametres/fractionnements" element={<Fractionnements />} />
        <Route path="/parametres/taux-commissions" element={<TauxCommissions />} />
        <Route path="/parametres/types-attestations" element={<TypesAttestations />} />
        <Route path="/parametres/sinistres" element={<ParametresSinistres />} />
        <Route path="/parametres/smig" element={<Smigs />} />
        <Route path="/parametres/age-limite-paiement-rente" element={<ListAgeLimitePaiementRente />} />
        <Route path="/parametres/penalite-cession" element={<PenalitesCession />} />
        <Route path="/parametres/pretium-doloris" element={<PretiumDoloris />} />
        <Route path="/parametres/ajouter-valeur-point-ip" element={<ValeurPointIP />} />
        <Route path="/autre-parametres/professions" element={<Professions />} />
        <Route path="/autre-parametres/villes" element={<Villes />} />
        <Route path="/autre-parametres/lieux" element={<AddLieu />} />
        <Route path="/autre-parametres/banques" element={<Banques />} />
        <Route path="/autre-parametres/exercices" element={<Exercices />} />
        <Route path="/autre-parametres/type-profils" element={<TypeProfils />} />
        <Route path="/autre-parametres/produits-attestation" element={<ProduitAttestation />} />
        <Route path="/autre-parametres/bareme-evaluation" element={<BaremeEvaluationOuvertureSinistre />} />
        <Route path="/autre-parametres/cles-de-repartition" element={<CleDeRepartition />} />
        <Route path="/autre-parametres/cle-de-repartition" element={<ClesRepartition />} />
        <Route path="/autre-parametres/cause-sinistres" element={<CausesSinistres />} />
        <Route path="/autre-parametres/prejudices" element={<Prejudices />} />
        <Route path="/autre-parametres/etablisements" element={<Etablissements />} />
        <Route path="/autre-parametres/type-etablissements" element={<TypeEtablissements />} />
        <Route path="/autre-parametres/autre-parametre" element={<AutresParametres />} />
        <Route path="/autre-parametres/nature-acte" element={<NatureActe />} />
        <Route path="/autre-parametres/somme-minimale-a-payer" element={<SommeMinList />} />
        <Route path="/autre-parametres/type-pieces" element={<TypePieces />} />
        <Route path="/autre-parametres/experts" element={<Experts />} />
        <Route path="/autre-parametres/numero-config" element={<NumeroConfig />} />
        <Route path="/autre-parametres/numero-police" element={<NumeroPoliceAddPage />} />
        <Route path="/autre-parametres/numero-sinistre" element={<NumeroSinistreAddPage />} />
        <Route path="/autre-parametres/entites-constat" element={<EntiteConstats />} />
    </>
);

export default ParametresRoutes;
